/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_area_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The chart is built entirely in your browser and your data never leaves your device.`)
};

const es_area_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. El gráfico se construye enteramente en tu navegador y tus datos nunca salen de tu dispositivo.`)
};

const de_area_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Das Diagramm wird vollständig in Ihrem Browser erstellt, und Ihre Daten verlassen Ihr Gerät nie.`)
};

const nl_area_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. De grafiek wordt volledig in je browser gebouwd en je data verlaat nooit je apparaat.`)
};

const fr_area_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Le graphique est entièrement construit dans votre navigateur et vos données ne quittent jamais votre appareil.`)
};

const it_area_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Il grafico viene costruito interamente nel tuo browser e i tuoi dati non lasciano mai il tuo dispositivo.`)
};

const pt_br2_area_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. O gráfico é construído inteiramente no seu navegador e seus dados nunca saem do seu dispositivo.`)
};

const pt_area_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. O gráfico é construído inteiramente no seu navegador e os seus dados nunca saem do seu dispositivo.`)
};

const ja_area_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。グラフは完全にブラウザ内で作成され、データが端末から外部に出ることはありません。`)
};

const zh_area_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的。图表完全在你的浏览器中生成，你的数据不会离开你的设备。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const area_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.area_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("area_faq_a4", locale)
	if (locale === "en") return en_area_faq_a4(inputs)
	if (locale === "es") return es_area_faq_a4(inputs)
	if (locale === "de") return de_area_faq_a4(inputs)
	if (locale === "nl") return nl_area_faq_a4(inputs)
	if (locale === "fr") return fr_area_faq_a4(inputs)
	if (locale === "it") return it_area_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_area_faq_a4(inputs)
	if (locale === "pt") return pt_area_faq_a4(inputs)
	if (locale === "ja") return ja_area_faq_a4(inputs)
	return zh_area_faq_a4(inputs)
};